import { Box, Typography } from '@mui/material';

const EmptyFeedbackList = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '200px',
        mt: 3,
      }}
    >
      <Typography variant="body1">No feedback yet!</Typography>
    </Box>
  );
};

export default EmptyFeedbackList;
